import { render } from "./Row.vue?vue&type=template&id=83227a02"
import script from "./Row.vue?vue&type=script&lang=ts"
export * from "./Row.vue?vue&type=script&lang=ts"

import "./Row.vue?vue&type=style&index=0&id=83227a02&lang=scss"
script.render = render

export default script